import { Button } from "@/components/ui/button";
import cswLogo from "@/assets/csw-logo-new.png";

export const InstHeader = () => {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-border/40 bg-background/85 backdrop-blur-xl"
      role="banner"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 gap-6">
          <a
            href="/"
            className="flex items-center gap-3 hover:opacity-80 transition-opacity flex-shrink-0"
            aria-label="CSW Home"
          >
            <img src={cswLogo} alt="CSW" className="h-10 w-auto" />
            <span className="font-display font-bold text-xl hidden sm:inline">CSW</span>
          </a>

          <Button
            asChild
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
          >
            <a href="/demo/">Try CSW now</a>
          </Button>
        </div>
      </div>
    </header>
  );
};
